import actionCreator from '../../shared/decorators/actionCreator';
import recordForUndo from '../../shared/decorators/recordForUndo';

import { REDUX_NAMESPACE } from './constants';
import { MIN_MEDIA_SYNC_TIMEOUT } from '../../../constants';

const ACTION_CREATORS = {
  /**
   * Set usePngSequence, which tells frame extraction to download individual PNG frames
   * @param {string} mediaId - CreativeDocumentMedium id
   * @param {boolean} usePngSequence
   * @returns {{mediaId: string, usePngSequence: boolean, }}
   */
  @recordForUndo()
  @actionCreator(REDUX_NAMESPACE)
  setMediaUsePngSequence(mediaId, usePngSequence) {
    return {
      mediaId,
      usePngSequence,
    };
  },

  /**
   * Start the sync process for the given server medium
   * @param {string} mediaServerId - ServerId (CreativeDocumentMedium.serverId) of the medium to sync
   * @param {string} mediaType - valid string from MEDIA_TYPE
   * @param {number} timeoutInMs - media sync timeout duration in milliseconds
   * @returns {{mediaServerId: string, mediaType: string, timeoutInMs: number }}
   */
  @actionCreator(REDUX_NAMESPACE)
  syncMedia(mediaServerId, mediaType, timeoutInMs = MIN_MEDIA_SYNC_TIMEOUT) {
    return {
      mediaServerId,
      mediaType,
      timeoutInMs,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  syncMediaProgress(mediaServerId, workerId) {
    return {
      mediaServerId,
      workerId,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  syncMediaComplete(mediaServerId, error) {
    return {
      error,
      mediaServerId,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  setMediaProcessors(mediaId, processors) {
    return {
      mediaId,
      processors,
    };
  },
};

export default ACTION_CREATORS;
